export enum ImageContext {
	Team = 'Team',
	Unknown = 'Unknown',
	Video = 'Video',
	VideoChapters = 'VideoChapters',
	VideoEdit = 'VideoEdit',
	Webcast = 'Webcast'
}
